import React, { useContext } from 'react';

import { NCRContext } from 'views'

import { Modal } from 'components/form/prototypes'

const ReturnModal = ({ showModal, setShowModal, setReturns }) => {

  const { setState } = useContext(NCRContext);

  const resetOrder = () => {
    setReturns(false);
    setState(prev => {
      let updated = { ...prev };
      updated.ncr.return.logistic_cost = 0;
      updated.ncr.return.returnItems = [];
      updated.ncr.return.returnPallets = [];
      updated.ncr.return.return_instructions = null;
      updated.ncr.return.booking_slot = null;
      updated.ncr.return.opening_times = null;
      updated.ncr.return.condition = null;
      updated.ncr.return.return_reason = null;
      updated.ncr.return.warehouse = null;
      updated.ncr.return.customer_name = null;
      updated.ncr.return.address = {
        address_line_1: null,
        address_line_2: null,
        address_city: null,
        address_country: null,
        address_code: null,
        address_postcode: null
      };
      updated.ncr.return.contact = {
        contact_name: null,
        contact_number: null,
        contact_email: null
      };
      return updated;
    });
  }

  const handleYes = () => {
    resetOrder();
    setShowModal(false);
  }
  const handleNo = () => {
    setShowModal(false);
  }

  const text = {
    body: (
      <>
        <b>This will remove any return order data.</b><br />
        <br />Are you sure you don't need a return order?
      </>
    ),
    yes: <>Yes, I'm sure</>,
    no: <>No, keep my order data</>
  }

  return (
    <Modal showModal={showModal} setShowModal={setShowModal} handleYes={handleYes} handleNo={handleNo} text={text} />
  )
}

export { ReturnModal };
